var _style, _rect, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "line {stroke: rgba(255,255,255,0.25);stroke-width: 1px;}rect {fill: rgba(94,95,103,0.625);}")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    vectorEffect: "non-scaling-stroke"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    vectorEffect: "non-scaling-stroke"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    vectorEffect: "non-scaling-stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.331016f810237ca105e0067295314767.svg";
export { ForwardRef as ReactComponent };